import { Icon } from "./Icon.tsx";

/** "Results Dashboard" toolbar icon — a dashboard/panel outline with a small trend line inside, distinct from StatisticsIcon.tsx's own full-width scatter/trend glyph (that one IS the whole icon; this one is a chart-within-a-panel, matching what the feature actually is: a panel that holds charts). */
export function ResultsDashboardIcon() {
  return (
    <Icon>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 9h18" />
      <path d="M6.5 17 10 12.5l2.5 2 4-5" />
    </Icon>
  );
}
